import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  tableSearchData: ''
};

const voucherSlice = createSlice({
  name: 'voucher',
  initialState,
  reducers: {
    setTableSearchData: (state, action) => {
      state.tableSearchData = action.payload;
    }
  }
});

export const { setTableSearchData } = voucherSlice.actions;

export default voucherSlice.reducer;
